import classnames from "clsx";
import { StyledHeader } from "./style";
import { IProps } from "./types";

const ModalFooter = ({ className, children, ...restProps }: IProps) => {
    return (
        <StyledHeader
            className={classnames(className, "modal-body")}
            {...restProps}
        >
            {children}
        </StyledHeader>
    );
};

export default ModalFooter;
